<template>
  <!-- 作品展示 -->
  <div class="exhibition-works">
    <div class="exhibition-works_div">
      <div class="home-title">
        <img src="@/assets/left.png" alt="" class="exhibition-works_img">
        <div class="home-title-main">
          <p> 学员作品展示</p>
          <p> 在美课教育，见证自己成长</p>
        </div>
        <img src="@/assets/right.png" alt="" class="exhibition-works_img">
      </div>
      <!-- tab -->
      <div class="swiper-box">
        <div class="content">
          <div v-show="tabIndex==0">
            <div style="width:100%;margin:20px auto;height:600px">
              <!-- Using the slider component -->
              <slider ref="exhibition-slider" :options="options">
                <!-- slideritem wrapped package with the components you need -->
                <template slot-scope="coverflow">
                  <slideritem v-for="(item,index) in someList" :pageLength="someList.length" :index="index"
                    :key="index">
                    <img :src="item.image[0].url" alt="" class="imgurl-width" alt="美课教育作品展示">
                  </slideritem>
                </template>
                <!-- Customizable loading -->
                <div slot="loading">loading...</div>
              </slider>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="kecheng-but" @click="showMore()">
      <span>查看更多学员作品</span>
    </button>
  </div>
</template>
<script>
  // import slider components
  import {
    slider,
    slideritem
  } from 'vue-concise-slider'
  export default {
    data() {
      return {
        tabIndex: 0, // 控制tab的切换
        someList: [],
        options: {
          effect: 'coverflow',
          thresholdDistance: 100, // Sliding distance threshold
          autoplay: 5000,
          thresholdTime: 300, // Sliding time threshold decision
          grabCursor: true, // Scratch style
          speed: 300, // Sliding speed
          loop: true
        }
      }
    },
    components: {
      slider,
      slideritem
    },
    created() {
      this.getData()
    },

    methods: {
      showMore() {
        this.$router.push({
          path: "/circle"
        })
      },
      getData() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/post/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            type: 4,
            recommend: 1,
            limit: 6
          }
        }).then(res => {
          this.someList = res.data.data.data
        })
      }
    },
  }
</script>
<style scoped>
  /********** 作品展示 **********/
  .kecheng-but {
    width: 355px;
    height: 74px;
    background: #3C71FF;
    box-shadow: 0px 3px 30px 0px rgb(60 113 255 / 40%);
    border-radius: 15px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 54px;
    border: none;
  }

  .exhibition-works .slider-container {
    overflow: visible;
  }

  .exhibition-works {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: auto;
    margin: 10px auto 80px;
  }

  .exhibition-works_div {
    height: 100%;
  }

  .slider_img {
    width: 900px;
    height: 545px;
    margin: 0 auto;
  }

  .imgurl-width {
    width: 960px;
    height: 600px;
    pointer-events: none;
  }

  /* tab导航 开始 */
  .swiper-box {
    position: relative;
  }

  .tab {
    /* height: 32px; */
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    margin-bottom: 15px;
  }

  .content {
    width: 1200px;
    padding: 10px;
    margin: 0 auto;
    /* overflow: hidden; */
    position: relative;
  }

  .tab li {
    width: 125px;
    height: 30px;
    padding: 5px 0;
    font-size: 16px;
    color: #34364e;
    margin-right: 20px;
    font-weight: 400;
    z-index: 100;
    text-align: center;
    line-height: 30px;
    border-radius: 40px;
    background-color: #f5f5f5;
  }

  li:last-child {
    margin-right: 0;
  }

  li.is_active {
    /* 选中的tab更改字体颜色和出现底边框*/
    color: #fff;
    background-color: #2271f7;
  }

  li:hover {
    cursor: pointer;
  }

  /* tab导航 结束 */
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/exhibition.vue